module.exports = __webpack_public_path__ + "static/media/not-found.a2e307de.svg";